"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DuplicateProjectModal_1 = __importDefault(require("./DuplicateProjectModal"));
exports.default = DuplicateProjectModal_1.default;
